<template>
  <v-autocomplete
    prepend-inner-icon="mdi-magnify"
    v-model="select"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    item-text="des_nom"
    item-value="cod_nom"
    class="mx-4"
    flat
    hide-no-data
    hide-details
    placeholder="Descripcion | Codigo"
    outlined
    dense
    return-object
    no-filter
    @change="selected"
  >
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title
          >{{ data.item.cod_nom }} - {{ data.item.des_nom.substring(0, 60) }}</v-list-item-title
        >
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import API from "@/lib/API";
import { mapState } from "vuex";
export default {
  props: {
    titular: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      seleccionado: false,
    };
  },
  watch: {
    search(val) {
      //val && val !== this.select && this.querySelections(val);
      if (val) {
        if (!this.seleccionado) {
          val = val.replace("/", "__");
          this.querySelections(val);
        } else {
          this.seleccionado = false;
        }
      }
    },
    select() {
      if (this.select) {
        this.$emit("input", this.select);
      } else {
        this.$emit("input", undefined);
      }
    },
  },
  computed: {
    ...mapState("nomenclador", ["Lista"]),
    practs(){
      return this.Lista.filter((x) => !x.cod_nom.startsWith('66'))
    }
  },
  methods: {
    querySelections(v) {
      this.loading = true;
      this.items = this.practs.filter(
        (x) => (x.cod_nom.indexOf(v) > -1 || x.des_nom.toUpperCase().indexOf(v.toUpperCase()) > -1) && !x.fec_baja 
      );
      this.loading = false;
    },
    selected() {
      this.seleccionado = true;
    },
    // filterObject(item, queryText, itemText) {
    //   return (
    //     item.apellido_y_nombre
    //       .toLocaleLowerCase()
    //       .indexOf(queryText.toLocaleLowerCase()) > -1 ||
    //     item.nro_doc.toString().indexOf(queryText) > -1
    //   );
    // },
  },
};
</script>
